/**
 * @packageDocumentation
 * @category Utility
 */

export type HighlightedPart = {
  highlight: boolean;
  start: number;
  text: string;
};

export const parseHighlightedParts = (text: string, matches: ReadonlyArray<readonly [number, number]>): HighlightedPart[] => {
  const clamped = matches
    .map(([start, end]) => [Math.max(0, Math.min(start, text.length)), Math.max(0, Math.min(end, text.length))] as [number, number])
    .filter(([start, end]) => end > start)
    .sort((a, b) => a[0] - b[0]);

  const merged: [number, number][] = [];
  for (const range of clamped) {
    const last = merged[merged.length - 1];
    if (last && range[0] <= last[1]) last[1] = Math.max(last[1], range[1]);
    else merged.push([range[0], range[1]]);
  }

  const parts: HighlightedPart[] = [];
  let cursor = 0;
  for (const [start, end] of merged) {
    if (start > cursor) parts.push({ highlight: false, start: cursor, text: text.slice(cursor, start) });
    parts.push({ highlight: true, start, text: text.slice(start, end) });
    cursor = end;
  }
  if (cursor < text.length) parts.push({ highlight: false, start: cursor, text: text.slice(cursor) });

  return parts;
};
